import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../services/app.service';
import { DataService } from '../../services/data.service';
import { SortingService } from '../../services/sort.service';
import { FormGroup } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap'; 
import { AuthService } from '../../services/auth.service';

//Components
import { TermsOfServiceModalComponent } from '../terms-of-service-modal/terms-of-service-modal.component';
import { PrivacyPolicyModalComponent } from '../privacy-policy-modal/privacy-policy-modal.component';
import { ContractTermsModalComponent } from '../contract-terms-modal/contract-terms-modal.component';
import { take } from 'rxjs/operators';

@Component({
    selector: 'sign-up',
    templateUrl: './sign-up.component.html'
})

export class SignUpComponent implements OnInit {
    schoolName: string;
    isLoading: boolean;
    errorList: any[];
    doneClicked: boolean;

    constructor (
        private modalSvc: BsModalService,
        private router: Router,
        public dataSvc: DataService,
        private sortSvc: SortingService,
        private authSvc: AuthService,
        private appSvc: AppService
    ) {
        this.isLoading = false;
    }

    ngOnInit() {
        this.getSignUpDaycare();
    }

    getSignUpDaycare() {
		try {
            // Query ChildPilot discounts
			this.dataSvc.getCPDiscounts();
            
            // Get daycare guid from url
			let url = window.location.href
			let daycareGUIDEncoded = this.dataSvc.getQueryStringParams(url, 'ID');
			let daycareGUID = atob(decodeURIComponent(daycareGUIDEncoded));

            // Check previous sesssion if no GUID
			if (daycareGUID == "") {
				this.getCurrentSession();
				return;
			}

			// Make Http Request to server to get potential daycare w/ given GUID
			this.dataSvc.getDaycare(daycareGUID,null, true).then(async (daycareInfo) => {
				if (daycareInfo) {

					let daycare = daycareInfo[0];
					this.dataSvc.setSignUpData(daycare);

					if (daycare.GUID) {
						this.dataSvc.saveItemToSessionStorage("currentSession", { daycareGUID: daycare.GUID });
						this.router.navigate(['sign-up']);
					}
				}
				else {
                    // Make http request to get /daycares w/ given GUID
					let existingDaycare = await this.dataSvc.getDaycare(daycareGUID,null, false);
					if(existingDaycare) {
						this.sendToSuccess(existingDaycare);
					}
					else {
						this.sendTo404();
					}

				}
			})
			.catch((err: any) => {
				console.log(err);
				this.sendTo404();
			})
		}
		catch (e) {
			this.sendTo404()	
		}
	}

	sendTo404() {
		this.dataSvc.daycare = {};
		this.router.navigate(['error404']);
	}

	sendToSuccess(daycare: any) {
		this.dataSvc.daycare = daycare;
		this.router.navigate(['success200']);
	}

	getCurrentSession() {
		let currentSession: any = this.dataSvc.getItemFromSessionStorage("currentSession");
		this.dataSvc.getItemFromSessionStorage("isComplete") ? this.sendTo404(): "";
		if (currentSession && currentSession.daycareGUID) {
            // query potiential schools by GUID
			this.dataSvc.getDaycare(currentSession.daycareGUID, null, true).then((daycareInfo) => {
				if (daycareInfo) {

					let daycare = daycareInfo[0];
					this.dataSvc.setSignUpData(daycare);

					if (daycare.GUID) {
						this.dataSvc.saveItemToSessionStorage("currentSession", { daycareGUID: daycare.GUID });
					}
				}
				else {
					this.sendTo404();
				}
			})
			.catch((err) => {
				console.log(err);
				this.sendTo404();
			})
		}
		else {
			this.sendTo404();
		}
	}

    goToSignUpAuth() {
        if(!this.dataSvc.signUpInfo.schoolName || !this.dataSvc.signUpInfo.adminEmail || this.dataSvc.signUpInfo.confirmAdminEmail != this.dataSvc.signUpInfo.adminEmail || !this.dataSvc.signUpInfo.phoneNumber || !this.dataSvc.signUpInfo.adminName || !this.dataSvc.signUpInfo.password || (this.dataSvc.signUpInfo.password && this.dataSvc.signUpInfo.password.length < 6)) {
            return;
        }

        this.isLoading = true;

        this.authSvc.signUp(this.dataSvc.signUpInfo.adminEmail, this.dataSvc.signUpInfo.password).then((userInfo) => {
            // Will need user uid from firebase.Auth
            let uid = userInfo.user.uid
            let promises: Promise<any>[] = [];

            // Logs user in so they're authenticated to navigate to sign-up-auth page
            promises.push(this.authSvc.loginEmail(this.dataSvc.signUpInfo.adminEmail, this.dataSvc.signUpInfo.password));

            // Creates user record  in /users, /{daycare}/users, and /{daycare}/employees
            promises.push(this.dataSvc.registerDirector(uid));
            
            Promise.all(promises).then(() => {
                this.dataSvc.setUID(uid);
                this.isLoading = false;
                this.router.navigate(['sign-up-auth']);
            })
            .catch((err) => {
                this.isLoading = false;
                console.log(err)
            })


        }).catch((err: any) => { 
            if(err && err.code == "auth/email-already-in-use") {
                this.authSvc.loginEmail(this.dataSvc.signUpInfo.adminEmail, this.dataSvc.signUpInfo.password).then((userInfo) => {
                    // Will need user uid from firebase.Auth
                    let uid = userInfo.user.uid
                    let promises: Promise<any>[] = [];
        
                    // Logs user in so they're authenticated to navigate to sign-up-auth page
                    promises.push(this.authSvc.loginEmail(this.dataSvc.signUpInfo.adminEmail, this.dataSvc.signUpInfo.password));
        
                    // Creates user record  in /users, /{daycare}/users, and /{daycare}/employees
                    promises.push(this.dataSvc.registerDirector(uid));
                    
                    Promise.all(promises).then(() => {
                        this.dataSvc.setUID(uid);
                        this.isLoading = false;
                        this.router.navigate(['sign-up-auth']); 
                    })
                    .catch((err) => {
                        this.isLoading = false;
                        console.log(err)
                    })
                }).catch((err: Error) => {
                    this.appSvc.showAlert(err.message,"danger-custom", true, 3000);
                    this.isLoading = false;
                    console.log(err);
                });
            }
            else {
                this.isLoading = false;
                console.log(err);
                this.appSvc.showAlert(err.message,"danger-custom", true, 3000);
            }

        });
    }

    openTOS() {
        let inputModal = this.modalSvc.show(TermsOfServiceModalComponent, {});
    }

    openPrivacyPolicy() {
        let inputModal = this.modalSvc.show(PrivacyPolicyModalComponent, {});
    }

    openContractTerms() {
        let inputModal = this.modalSvc.show(ContractTermsModalComponent, {});
    }

    openLearnMore() {
        window.open("https://www.childpilot.com", "_blank");
    }
}